var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldType } from '../../../redux/questionnaire/typings';
import { t } from '../../../strings/i18n/i18n';
import styled from 'styled-components';
import { faBellExclamation } from '@fortawesome/pro-light-svg-icons';
import { generateUUID } from 'syf-js-utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import theme from '../../../theme';
import { fontWeights, spacing } from 'syf-component-library/defaultTheme';
var AdditionalQuestionContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  font-size: 14px;\n  padding: ", "px;\n  background: ", ";\n"], ["\n  display: flex;\n  font-size: 14px;\n  padding: ", "px;\n  background: ", ";\n"])), spacing.base, theme.colors.greyNinetyEight);
var IconWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-right: 10px;\n"], ["\n  margin-right: 10px;\n"])));
var Content = styled.p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin-bottom: ", "px;\n  span {\n    font-weight: ", ";\n  }\n  &:last-child {\n    margin-bottom: 0;\n  }\n"], ["\n  margin-bottom: ", "px;\n  span {\n    font-weight: ", ";\n  }\n  &:last-child {\n    margin-bottom: 0;\n  }\n"])), spacing.base, fontWeights.bold);
var AdditionalQuestionContent = function (_a) {
    var currentQuestion = _a.currentQuestion;
    var answers = currentQuestion.answers;
    var fieldType = answers[0].fieldType;
    var additionalCopy = [];
    if (fieldType === FieldType.TextArea) {
        additionalCopy.push({
            content: t('questionnaire.securityDisclaimerReminder'),
            title: t('questionnaire.securityDisclaimerReminderTitle'),
            key: generateUUID()
        }, {
            content: t('questionnaire.securityDisclaimerHelpNote'),
            title: t('questionnaire.securityDisclaimerNoteTitle'),
            key: generateUUID()
        });
    }
    if (additionalCopy.length === 0) {
        return null;
    }
    return (_jsxs(AdditionalQuestionContainer, { children: [_jsx(IconWrapper, { children: _jsx(FontAwesomeIcon, { icon: faBellExclamation }) }), _jsx("div", { children: additionalCopy.map(function (_a) {
                    var content = _a.content, key = _a.key, title = _a.title;
                    return (_jsxs(Content, { children: [_jsx("span", { children: "".concat(title, " ") }), content] }, key));
                }) })] }));
};
export default AdditionalQuestionContent;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map